import WidgetModule from "@eisinc/Overrides/Widgets/ContactUs/ContactForm";

export * from "@eisinc/Overrides/Widgets/ContactUs/ContactForm";

export default WidgetModule;
